<template>
    <div id="fssContractList">
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="getList">
            <div class="body">
                <div class="card" v-for="(item,index) in list" :key="index" @click="$router.push({path:'/fssContractDetail',query:{id:item.contractId}})">
                    <p>
                        <span class="title">
                            <span :class="{'ellipsis':!item.showTitle}" @click.stop="item.showTitle = !item.showTitle">{{item.house.address}}</span>
                            （{{item.contract.tenantType?fssTenantTypeList[item.contract.tenantType - 1]:'-'}}）
                        </span>
                    </p>
                    <p>
                        <span>编码：{{item.contract.number}}</span>
                        <span class="theme-color">{{pContractStatusList[item.contract.status-1]}}</span>
                    </p>
                    <p>
                        <span>业主：{{item.property.name}} </span>
                    </p>
                    <p>
                        <span>生效日期：{{item.contract.activeDate?item.contract.activeDate.slice(0,10):""}}</span>
                    </p>
                    <p>
                        <span>开始日期：{{item.contract.startDate?item.contract.startDate.slice(0,10):""}}</span>
                    </p>
                    <p>
                        <span>结束日期：{{item.contract.endDate?item.contract.endDate.slice(0,10):""}}</span>
                    </p>
                    <!-- <p>
                        <span>创建信息：{{item.creator}} | {{item.createDate}}</span>
                        <span>{{item.rental}}元/月</span>
                    </p> -->
                </div>
            </div>
        </van-list>
        <div style="height:1.2rem"></div>
        <div class="btn">
            <van-button class="font1 line" v-if="$store.state.buttonAuth.indexOf('crm_fssContractAdd')>-1" type="primary" block @click="$router.push({path:'fssContractAdd'})">新增</van-button>
            <van-button class="font1" type="primary" block @click="showSearch = !showSearch">筛选</van-button>
        </div>
        <transition name="van-fade">
            <div v-show="showSearch" class="search">
                <div class="field">
                    <div class="searchT">编码</div>
                    <van-field left-icon="label-o" maxlength="20" v-model="listQuery.numberInfo" placeholder="合约编码/金蝶编码" />
                </div>
                <div class="field">
                    <div class="searchT">业主</div>
                    <van-field left-icon="friends-o" maxlength="20" v-model="listQuery.propertyInfo" placeholder="业主姓名/业主电话" />
                </div>
                <div class="field">
                    <div class="searchT">房源</div>
                    <van-field left-icon="wap-home-o" maxlength="20" v-model="listQuery.houseAddress" placeholder="房源地址" />
                </div>
                <div class="field field1">
                    <div class="searchT">承租方式</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.tenantType == ''}" @click="listQuery.tenantType = ''">全部</div>
                        <div :class="{'active':listQuery.tenantType == 1}" @click="listQuery.tenantType = 1">包租</div>
                        <div :class="{'active':listQuery.tenantType == 2}" @click="listQuery.tenantType = 2">托管</div>
                            <div :class="{'active':listQuery.tenantType == 3}" @click="listQuery.tenantType = 3">托管+</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">合约状态</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.status == ''}" @click="listQuery.status = ''">全部</div>
                        <div v-for="(item,index) in pContractStatusList" :key="index" :class="{'active':listQuery.status == index+1}" @click="listQuery.status = index+1">{{item}}</div>
                    </div>
                </div>
                <div class="field field1">
                    <div class="searchT">到期时间</div>
                    <div class="flex">
                        <div :class="{'active':listQuery.expireDays == ''}" @click="listQuery.expireDays = ''">全部</div>
                        <div :class="{'active':listQuery.expireDays == -1}" @click="listQuery.expireDays = -1">已过期</div>
                        <div :class="{'active':listQuery.expireDays == 7}" @click="listQuery.expireDays = 7">7天内</div>
                        <div :class="{'active':listQuery.expireDays == 15}" @click="listQuery.expireDays = 15">15天内</div>
                        <div :class="{'active':listQuery.expireDays == 30}" @click="listQuery.expireDays = 30">30天内</div>
                    </div>
                </div>
                <div style="height:1.2rem;"></div>
                <div class="bottom">
                    <van-button class="font5" type="default" @click="resetSearch">重置</van-button>
                    <van-button class="font5" type="primary" @click="searchConfirm">确定</van-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestFssContractList } from "@/api";
import { accSub } from "@/utils";
export default {
    name: "fssContractList",
    data() {
        return {
            loading: false,
            finished: false,
            showSearch: false,
            listQuery: {
                numberInfo: "",
                propertyInfo: "",
                houseAddress: "",
                status: "",
                tenantType: "",
                expireDays: "",
                pageNumber: 1,
                pageSize: 10,
            },
            list: [],
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "pContractStatusList",
             'fssTenantTypeList'
        ]),
    },
    activated() {
        this.listQuery.pageNumber = 1;
        this.finished = false;
        this.list = [];
        this.getList();
    },
    created() {
        // this.getList();
    },
    mounted() {},
    methods: {
        getList() {
            this.loading = true;
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestFssContractList(this.listQuery)
                .then((res) => {
                    toast1.clear();
                    if (this.finished) return;
                    res.data.records.forEach((d) => {
                        d.showTitle = false;
                    });
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                    toast1.clear();
                });
        },
        resetSearch() {
            this.listQuery = {
                numberInfo: "",
                propertyInfo: "",
                houseAddress: "",
                status: "",
                tenantType: "",
                expireDays: "",
                pageNumber: 1,
                pageSize: 10,
            };
            this.list = [];
            this.finished = false;
            this.showSearch = false;
            this.getList();
        },
        searchConfirm() {
            this.finished = false;
            this.showSearch = false;
            this.listQuery.pageNumber = 1;
            this.list = [];
            this.getList();
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    margin-top: 0.3rem;
    .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        color: $color9;
        padding: 0.2rem 0;
        // margin: 0.2rem 0;
        p {
            text-align: left;
            display: flex;
            justify-content: space-between;
            padding: 0 0.4rem;
            line-height: 0.8rem;
            > span {
                height: 0.8rem;
            }
            .title {
                font-size: 0.35rem;
                font-weight: 600;
                height: auto;
                color: #000;
                // span {
                //     max-width: 4.5rem;
                //     vertical-align: top;
                //     overflow: hidden;
                //     display: inline-block;
                //     height: auto;
                //     text-overflow: ellipsis;
                // }
                // .ellipsis {
                //     white-space: nowrap;
                // }
            }
            .big {
                font-size: 0.4rem;
            }
        }
    }
    > .card:first-child {
        margin-top: 0;
    }
    .theme-color {
        color: $theme-color;
    }
}
.search {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    background-color: #fff;
    z-index: 99;
    overflow: scroll;
    // padding-top: 0.4rem;
    .field {
        padding: 0 0.7rem;
        .searchT {
            text-align: left;
            font-size: 0.41rem;
            font-weight: 600;
            color: #666666;
            margin: 0.4rem 0;
            // padding-left: 0.4rem;
        }
        /deep/.van-cell {
            border: 1px solid $border-color;
        }
        .flex {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding-left: 0.35rem;
            > div {
                margin: 0.35rem;
                width: 2.4rem;
                height: 0.8rem;
                line-height: 0.8rem;
                border: 1px solid $border-color;
                &.active {
                    border: 1px solid $theme-color;
                    color: $theme-color;
                }
            }
        }
    }
    .field1 {
        padding: 0;
        .searchT {
            padding: 0 0.7rem;
        }
    }
    .bottom {
        position: fixed;
        bottom: 0;
        display: flex;
        width: 100%;
        /deep/.van-button--primary {
            margin-left: -1px;
            border: none;
            border-radius: 0;
        }
        .font5 {
            width: 51%;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
